import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminAppBar from "../../../adminComponents/AdminAppBar";
import BackArrows from "../../../Form/BackArrow/BackArrows";
import StepProgress from "../StepProgress";
import { getIcons, userUid } from "../../../Constant/Constant";
import { TbFileSymlink } from "react-icons/tb";
import { MdAddCircleOutline } from "react-icons/md";
import PropertiesService from "../../../Services/PropertiesService";
import { FiSearch } from "react-icons/fi";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import {
  plotStatusIds,
  propertySaleTypes,
  roadFacingSides,
} from "../../../../Enum";
import StatusDropdown from "../StatusDropdown";
import ApartmentPropertyInfoForm from "./ApartmentPropertyInfoForm";
import ApartmentUnitTable from "./ApartmentUnitTable";
import ApartmentUnitForm from "./ApartmentUnitForm";
import TowerInfoForm from "./TowerInfoForm";

const ApartmentPropertyManage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedPropertyDetails,
    propertySaleType,
    propertyId,
    propertyName,
    propertyTypeId,
    propertyInfoStatus = false,
  } = location.state || {};

  const editMode = !!propertyId;
  const propertySaleTypesName = propertySaleTypes.find(
    (item) => item.id === propertySaleType
  )?.label;

  const icons = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [isNewUnit, setIsNewUnit] = useState(false);
  const [previousTotalUnitRow, setPreviousTotalUnitRow] = useState(0);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [towers, setTowers] = useState([]);
  const [towerId, setTowerId] = useState("");
  const [totalUnitsPerTower, setTotalUnitsPerTower] = useState({});
  const [lastUnitTrigger, setLastUnitTrigger] = useState(false);
  const [isLoading , setIsLoading] = useState(false);

  const [propertyInfo, setPropertyInfo] = useState({
    docId: "",
    name: "",
    locationId: "",
    propertyId: "",
    geoLocation: "",
    propertyTypeId: selectedPropertyDetails?.id || "",
    propertySaleTypeId: propertySaleType || "",
    propertyType: selectedPropertyDetails?.label || "",
    underOfGovernance: "",
    salesTeamIds: [],
    basicAmenitiesIds: [],
    futureAmenitiesIds: [],
    nearByAmenitiesIds: [],
    possessionDate: "",
    propertyImages: [],
    propertyVideos: [],
    propertyDocuments: [],
    ageOfTheProperty: 0,
    propertyFlyers: [],
    propertyBlueprints: [],
    propertyThumbnail: "",
    overAllSqft: 0,
    dtcpNo: "",
    guidelineValue: 0,
    documentType: "",
    landmark: "",
    roiPercentage: "",
    roiYear: "",
    reraId: "",
    surveyFee: 0,
    surveyNo: "",
    documentCharge: 0,
    purchaseDaysCount: 0,
    propertyPurchasedDate: "",
    sro: "",
    taluk: "",
    address: "",
    locationLink: "",
    totalProjectWorth: 0,
    propertySellerName: "",
    propertySellerPhoneNumber: "",
    createdById: userUid,
    modifiedById: "",
    overAllSaleableSqft: 0,
    totalAvailableUnits: 0,
    overAllAvailableSqft: 0,
    availableMinSqft: 0,
    availableMaxSqft: 0,
    availableMinBudget: 0,
    availableMaxBudget: 0,
    bookedUnitcount: 0,
    overAllBookedSqft: 0,
    agreementUnitcount: 0,
    overAllAgreementSqft: 0,
    registeredUnitcount: 0,
    overAllRegisteredSqft: 0,
    constructionType: "",
  });

  const [units, setUnits] = useState([]);
  const [modifiedUnitIds, setModifiedUnitIds] = useState(new Set());
  const [exitingTowerCount, setExitingTowerCount] = useState();

  const filterUnits = useCallback(
    (towerNum) => {
      let filtered = units.filter(
        (unit) =>
          unit !== null &&
          unit !== undefined &&
          unit.towerNum === towerNum &&
          !unit.isArchived
      );

      if (searchTerm.trim()) {
        filtered = filtered.filter((unit) =>
          unit.unitNo?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      if (selectedStatus !== "all") {
        filtered = filtered.filter(
          (unit) =>
            unit.unitStatus?.name.toLowerCase() === selectedStatus.toLowerCase()
        );
      }

      setFilteredUnits(filtered);
    },
    [units, searchTerm, selectedStatus]
  );

  const fetchPropertyData = async () => {
    if (editMode && propertyId && propertyTypeId) {
      try {
        const propertyResponse = await PropertiesService.getPropertyById(
          propertyId,
          propertyTypeId
        );
        const apiData = propertyResponse.data?.propertyData || {};

        setPropertyInfo((prev) => ({
          ...prev,
          docId: propertyId,
          name: apiData.name || "",
          locationId: apiData.location?.id || "",
          geoLocation: apiData.geoLocation || "",
          propertyId: apiData.propertyId || "",
          propertyType:
            apiData.propertyType?.name || selectedPropertyDetails?.label || "",
          propertyTypeId:
            apiData.propertyType?.id || selectedPropertyDetails?.id || "",
          propertySaleTypeId:
            apiData.propertySaleType?.id || propertySaleType || "",
          underOfGovernance: apiData.underOfGovernance || "",
          salesTeamIds: apiData.salesTeam?.map((team) => team.id) || [],
          basicAmenitiesIds: apiData.basicAmenities?.map((a) => a.id) || [],
          futureAmenitiesIds: apiData.futureAmenities?.map((a) => a.id) || [],
          nearByAmenitiesIds: apiData.nearByAmenities?.map((a) => a.id) || [],
          propertyImages: apiData.propertyImages?.map((img) => img.doc) || [],
          propertyVideos:
            apiData.propertyVideos?.map((video) => video.doc) || [],
          propertyDocuments:
            apiData.propertyDocuments?.map((doc) => doc.doc) || [],
          propertyFlyers:
            apiData.propertyFlyers?.map((flyer) => flyer.doc) || [],
          propertyBlueprints:
            apiData.propertyBlueprints?.map((bp) => bp.doc) || [],
          propertyThumbnail: apiData.propertyThumbnail || "",
          overAllSqft: apiData.overAllSqft || 0,
          dtcpNo: apiData.dtcpNo || "",
          guidelineValue: apiData.guidelineValue || 0,
          documentType: apiData.documentType || "",
          landmark: apiData.landmark || "",
          purchaseDaysCount: apiData.purchaseDaysCount || 0,
          roiPercentage: apiData.roiPercentage || "",
          roiYear: apiData.roiYear || "",
          reraId: apiData.reraId || "",
          ageOfTheProperty: apiData.ageOfTheProperty || 0,
          surveyFee: apiData.surveyFee || 0,
          surveyNo: apiData.surveyNo || "",
          documentCharge: apiData.documentCharge || 0,
          propertyPurchasedDate: apiData.propertyPurchasedDate || "",
          possessionDate: apiData.possessionDate || "",
          constructionType: apiData.constructionType || "",
          sro: apiData.sro || "",
          taluk: apiData.taluk || "",
          address: apiData.address || "",
          locationLink: apiData.locationLink || "",
          totalProjectWorth: apiData.totalProjectWorth || 0,
          propertySellerName: apiData.propertySellerName || "",
          propertySellerPhoneNumber: apiData.propertySellerPhoneNumber || "",
          overAllSaleableSqft: apiData.overAllSaleableSqft || 0,
          totalAvailableUnits: apiData.totalAvailableUnits || 0,
          overAllAvailableSqft: apiData.overAllAvailableSqft || 0,
          availableMinSqft: apiData.availableMinSqft || 0,
          availableMaxSqft: apiData.availableMaxSqft || 0,
          availableMinBudget: apiData.availableMinBudget || 0,
          availableMaxBudget: apiData.availableMaxBudget || 0,
          bookedUnitcount: apiData.bookedUnitcount || 0,
          overAllBookedSqft: apiData.overAllBookedSqft || 0,
          agreementUnitcount: apiData.agreementUnitcount || 0,
          overAllAgreementSqft: apiData.overAllAgreementSqft || 0,
          registeredUnitcount: apiData.registeredUnitcount || 0,
          overAllRegisteredSqft: apiData.overAllRegisteredSqft || 0,
        }));

        const towerResponse = await PropertiesService.getTowerInfoByPropertyId(
          propertyId
        );
        const towerData = towerResponse.data?.towers || [];
        const defaultTowerId = towerData[0]?.id || "";
        setExitingTowerCount(towerData?.length);

        const formattedTowers = towerData.map((tower, index) => ({
          id: tower.id,
          towerNum: index + 1,

          towerName: tower.towerName,
          overAllTowerArea: tower.overAllTowerArea,
          towerBuildUpArea: tower.towerBuildUpArea,
          towerTerraceArea: tower.towerTerraceArea,
          totalFloors: tower.totalFloors,
          totalBuildUpCost: tower.totalBuildUpCost,
          highRise: tower.highRise,
          createdBy: tower.createdBy || userUid,
        }));

        setTowers(formattedTowers);
        setTotalUnitsPerTower(
          formattedTowers.reduce(
            (acc, tower) => ({
              ...acc,
              [tower.towerNum]:
                tower.totalUnits || parseInt(tower.totalFloors) || 0,
            }),
            {}
          )
        );

        const unitsResponse =
          await PropertiesService.getApartmentUnitsByPropertyId(
            propertyId,
            defaultTowerId
          );
        const unitsData = unitsResponse.data?.units || [];
        setUnits(unitsData);

        setPreviousTotalUnitRow(unitsData.length);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    fetchPropertyData();
  }, [propertyId, editMode]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    filterUnits(towers[0]?.towerNum || 1);
  };

  const handleStatusFilter = (option) => {
    setSelectedStatus(option.id === "all" ? "all" : option.label);
  };

  const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          updated.locationLink = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
        } else {
          updated.locationLink = "";
        }
      }
      return updated;
    });
  };

  const handleArrayFieldChange = (field, newArray) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [field]: newArray,
    }));
  };

  const handleNestedPropertyInfoChange = (parentKey, childKey, value) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [childKey]: value,
      },
    }));
  };

  const handleTowerInfoChange = (towersData) => {
    setTowers(towersData);
    console.log(towersData);
  };

  const handleTotalUnitsChange = (towerNum, newValue) => {
    setTotalUnitsPerTower((prev) => ({
      ...prev,
      [towerNum]: newValue,
    }));
  };

  const handleTowerInfoManage = async () => {
    const towerNames = towers.map((t) => t.towerName.trim().toLowerCase());
    const hasDuplicateNames = new Set(towerNames).size !== towerNames.length;

    if (hasDuplicateNames) {
      showErrorToast("Duplicate tower names are not allowed!");
      return;
    }

    for (const tower of towers) {
      if (!tower.towerName?.trim()) {
        showErrorToast("Each tower must have a name.");
        return;
      }

      const floors = parseInt(tower.totalFloors);
      if (isNaN(floors) || floors <= 0) {
        showErrorToast(
          `Tower "${tower.towerName}" must have a valid number of total floors.`
        );
        return;
      }
    }
    setIsLoading(true)

    try {
      const towerDetailsPayload = towers.map((tower) => ({
        towerId: tower.id || undefined,
        towerName: tower.towerName || "",
        overAllTowerArea: parseFloat(tower.overAllTowerArea) || 0,
        towerBuildUpArea: parseFloat(tower.towerBuildUpArea) || 0,
        towerTerraceArea: parseFloat(tower.towerTerraceArea) || 0,
        totalFloors: parseInt(tower.totalFloors) || 0,
        totalBuildUpCost: parseFloat(tower.totalBuildUpCost) || 0,
        highRise: tower.highRise.map((range) => ({
          startFloor: parseInt(range.startFloor) || 1,
          endFloor: parseInt(range.endFloor) || 1,
          pricePerFloor: parseFloat(range.pricePerFloor) || 0,
        })),
        createdBy: tower.createdBy || userUid,
        modifiedBy: editMode ? userUid : undefined,
        totalUnits: totalUnitsPerTower[tower.towerNum] || 0,
      }));

      const payload = {
        docId: propertyInfo.docId,
        towerDetails: towerDetailsPayload,
      };

     // console.log("exitingTowerCount", exitingTowerCount);

      // if (towers?.length === 0) {
      //   const response = await PropertiesService.createTowerInfo(payload);
      //   setTowers(response.data?.data || towers);
      // }
      if (exitingTowerCount > 0) {
        await PropertiesService.updateTowerInfo(propertyInfo.docId, payload);
        showSuccessToast("Towers updated successfully!");
      } else {
        const response = await PropertiesService.createTowerInfo(payload);
        setTowers(response.data?.data || towers);
        showSuccessToast("Towers created successfully!");
      }

      setCurrentStep(currentStep + 1);
    } catch (err) {
      console.error("Error managing tower info:", err);
    }finally{
      setIsLoading(false)
    }
  };

  const handleAddUnit = () => {
    const defaultStatus = plotStatusIds.find(
      (status) => status.label === "Available"
    );

    setEditingUnit({
      order: (totalUnitsPerTower[towerId] || 0) + 1,
      unitNo: "",
      carpetArea: 0,
      buildUpArea: 0,
      terraceArea: 0,
      saleableArea: 0,
      guidelineSqftPrice: 0,
      floors: 0,
      totalBhk: 0,
      basePrice: 0,
      baseRate: 0,
      allInclusiveCharges: 0,
      bathrooms: "",
      roadFacingSide: "",
      registrationCharge: 0,
      furnished: "",
      parking: "",
      coveredParking: "",
      lift: "",
      balconyDirection: "",
      balconyView: "",
      notes: "",
      statusName : defaultStatus.label ,
      unitStatus: defaultStatus
        ? { id: defaultStatus.id, name: defaultStatus.label }
        : { id: "", name: "N/A" },
      createdBy: userUid,
      towerId: towerId || towers[0]?.id || "",
      towerNum:
        towers.find((t) => t.id === towerId)?.towerNum ||
        towers[0]?.towerNum ||
        1,
    });
    setIsNewUnit(true);
    setIsSliderOpen(true);
  };

  const handleEditUnit = (unit) => {
    setEditingUnit({
      ...unit,
      floorsBhk:
        unit.floorsBhk ||
        Array(unit.floors || 0)
          .fill()
          .map((_, i) => ({
            floor: i + 1,
            bhk: unit.floorsBhk?.[i]?.bhk || 0,
          })),   
         
    });
    setIsNewUnit(false);
    setIsSliderOpen(true);
  };

  const clickLoading = (value) => {
    console.log("Click Loading", value);
    setIsLoading(value);
  };
  
  const handleSavePropertyApartmentUnit = async () => {    
      setLastUnitTrigger(true);
      setTimeout(()=>{
        navigate(-1);
      },1700)
  };
  

  const handleBack = () => {
    navigate(-1);
  };

  const handlePrevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleNextViewStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrevViewStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      setCurrentStep(2);
    }
  };

  const handlepropertyManage = async () => {
    if (!propertyInfo.name.trim()) {
      showErrorToast("Property name is required!");
      return;
    }
    if (propertyInfo?.overAllSqft <= 0) {
      showErrorToast("Overall Square Feet is required!");
      return;
    }
    // if (propertyInfo?.guidelineValue <= 0) {
    //   showErrorToast("Guideline Value is required!");
    //   return;
    // }
    if (propertyInfo.geoLocation.trim() === "") {
      showErrorToast("Geolocation is required!");
      return;
    }
    if (propertyInfo.locationId.trim() === "") {
      showErrorToast("Location is required!");
      return;
    }
    if (propertyInfo.address.trim() === "") {
      showErrorToast("Address is required!");
      return;
    }

    setIsLoading(true)

    try {
      let savedPropertyId = propertyInfo.docId;
      let propertyPayload = {
        name: propertyInfo.name || null,
        locationId: propertyInfo.locationId || null,
        geoLocation: propertyInfo.geoLocation || null,
        propertyTypeId: propertyInfo?.propertyTypeId || null,
        propertySaleTypeId: propertyInfo.propertySaleTypeId || null,
        underOfGovernance: propertyInfo.underOfGovernance || null,
        salesTeamIds: Array.isArray(propertyInfo.salesTeamIds)
          ? propertyInfo.salesTeamIds
          : [propertyInfo.salesTeamIds].filter(Boolean),
        basicAmenitiesIds: Array.isArray(propertyInfo.basicAmenitiesIds)
          ? propertyInfo.basicAmenitiesIds
          : [propertyInfo.basicAmenitiesIds].filter(Boolean),
        futureAmenitiesIds: Array.isArray(propertyInfo.futureAmenitiesIds)
          ? propertyInfo.futureAmenitiesIds
          : [propertyInfo.futureAmenitiesIds].filter(Boolean),
        nearByAmenitiesIds: Array.isArray(propertyInfo.nearByAmenitiesIds)
          ? propertyInfo.nearByAmenitiesIds
          : [propertyInfo.nearByAmenitiesIds].filter(Boolean),
        propertyImages: Array.isArray(propertyInfo.propertyImages)
          ? propertyInfo.propertyImages
          : [propertyInfo.propertyImages].filter(Boolean),
        propertyVideos: Array.isArray(propertyInfo.propertyVideos)
          ? propertyInfo.propertyVideos
          : [propertyInfo.propertyVideos].filter(Boolean),
        propertyDocuments: Array.isArray(propertyInfo.propertyDocuments)
          ? propertyInfo.propertyDocuments
          : [propertyInfo.propertyDocuments].filter(Boolean),
        propertyFlyers: Array.isArray(propertyInfo.propertyFlyers)
          ? propertyInfo.propertyFlyers
          : [propertyInfo.propertyFlyers].filter(Boolean),
        propertyBlueprints: Array.isArray(propertyInfo.propertyBlueprints)
          ? propertyInfo.propertyBlueprints
          : [propertyInfo.propertyBlueprints].filter(Boolean),
        propertyThumbnail: propertyInfo.propertyThumbnail || null,
        overAllSqft: Number(propertyInfo.overAllSqft) || 0,
        dtcpNo: propertyInfo.dtcpNo || null,
        guidelineValue: Number(propertyInfo.guidelineValue) || 0,
        documentType: propertyInfo.documentType || null,
        landmark: propertyInfo.landmark || null,
        roiPercentage: Number(propertyInfo.roiPercentage) || null,
        roiYear: Number(propertyInfo.roiYear) || null,
        reraId: propertyInfo.reraId || null,
        surveyFee: Number(propertyInfo.surveyFee) || 0,
        ageOfTheProperty: Number(propertyInfo.ageOfTheProperty) || 0,
        surveyNo: propertyInfo.surveyNo || null,
        documentCharge: Number(propertyInfo.documentCharge) || 0,
        propertyPurchasedDate: propertyInfo.propertyPurchasedDate || null,
        sro: propertyInfo.sro || null,
        possessionDate: propertyInfo.possessionDate || null,
        taluk: propertyInfo.taluk || null,
        address: propertyInfo.address || null,
        locationLink: propertyInfo.locationLink || null,
        totalProjectWorth: Number(propertyInfo.totalProjectWorth) || 0,
        propertySellerName: propertyInfo.propertySellerName || null,
        propertySellerPhoneNumber:
          propertyInfo.propertySellerPhoneNumber || null,
        constructionType: propertyInfo.constructionType || null,
      };

      if (editMode) {
        propertyPayload = {
          ...propertyPayload,
          docId: propertyInfo.docId,
          modifiedById: userUid || null,
        };
        await PropertiesService.updateProperty(propertyPayload);
        showSuccessToast("Property updated successfully!");
      } else {
        propertyPayload = {
          ...propertyPayload,
          createdById: userUid || null,
        };
        const response = await PropertiesService.createProperty(
          propertyPayload
        );
        savedPropertyId = response.data.id;
        setPropertyInfo((prev) => ({ ...prev, docId: savedPropertyId }));
        showSuccessToast("Property created successfully!");
      }

      setCurrentStep(currentStep + 1);
    } catch (error) {
      console.error("Error saving property:", error);
    }finally{
      setIsLoading(false);
    }
  };

  const handleSelectedTowerId = (towerId) => {
    setTowerId(towerId);
  };

  const handleOneStep = () => {
    setCurrentStep(1);
  };

  const handleTwoStep = () => {
    setCurrentStep(2);
  };

  const handleThreeStep = () => {
    setCurrentStep(3);
  };

  return (
    <div className="bg-appGrayBackground min-h-screen pb-16">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-8 px-6 mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-6 mb-4 md:mb-0">
            <BackArrows onClick={handleBack} />
            <h1 className="text-2xl md:text-3xl font-semibold">
              {selectedPropertyDetails?.label || propertyName}
            </h1>
          </div>
          <div className="flex gap-4">
            {currentStep === 1 && (
              <button
              disabled={isLoading}
              className={`px-6 py-3 w-44 text-center ${
                isLoading 
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-customGreen"
              } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
               onClick={handlepropertyManage}
              >
                {propertyName ? "Update Property" : "Next & Publish"}
              </button>
            )}

     
                {currentStep === 2 && (
                  <button
                  disabled={isLoading}
                  className={`px-6 py-3  text-center ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-customGreen"
                  } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                   onClick={handleTowerInfoManage}
                  >
                    {propertyName ? "Update Tower" : "Next & Publish Tower"}
                  </button>
                )}
             
            {currentStep === 3 && (
              <>
                {propertyName ? (
                  <>
                    {/* <form onSubmit={handleSearchSubmit} className="relative w-full md:w-[385px]">
                      <input
                        type="text"
                        placeholder="Search Unit Number"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="w-full pl-3 pr-12 h-[50px] shadow appearance-none border rounded-[10px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                      <button
                        type="submit"
                        className="absolute right-0 w-[50px] h-[50px] top-1/2 transform -translate-y-1/2 text-white bg-customGreen p-2 rounded-r-[10px]"
                      >
                        <FiSearch size={25} className="ml-1" />
                      </button>
                    </form>
                    <StatusDropdown
                      onSelect={handleStatusFilter}
                      options={[{ id: "all", label: "All Statuses" }, ...plotStatusIds]}
                    /> */}
                  </>
                ) : (
                  <>
                    <button
                      className="px-6 py-3 w-44 text-center bg-customGreen text-white flex items-center justify-center gap-2 rounded-[10px]"
                     // onClick={handlePrevStep}
                    >
                      <TbFileSymlink className="text-xl" />
                      <span>Bulk Upload</span>
                    </button>
                  </>
                )}
                <button
                 disabled={isLoading}
                 className={`px-6 py-3 w-44 text-center ${
                   isLoading
                     ? "bg-gray-400 cursor-not-allowed"
                     : "bg-customGreen"
                 } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                    onClick={handleSavePropertyApartmentUnit}
                >
                  <MdAddCircleOutline className="text-xl font-semibold" />
                  <span>{editMode ? "Update" : "Create"}</span>
                </button>
              </>
            )}
          </div>
        </div>

        <div className="bg-white mt-14 rounded-lg py-[30px]">
          <div
            className={`${
              propertyName ? "flex items-center justify-between px-8" : ""
            }`}
          >
            <StepProgress
              currentStep={currentStep}
              handlePrevStep={handlePrevStep}
              handleNextViewStep={handleNextViewStep}
              handlePrevViewStep={handlePrevViewStep}
              handleOneStep={handleOneStep}
              handleTwoStep={handleTwoStep}
              handleThreeStep={handleThreeStep}
              isEdit={propertyInfoStatus}
              saleType={propertySaleType}
              propertyType={"Apartment"}
            />

            {/* {propertyName && currentStep === 1 && (
              <div>
                <button
                  className="px-6 py-3 w-44 text-center bg-customGreen text-white rounded-md"
                  onClick={handlepropertyManage}
                >
                  Update
                </button>
              </div>
            )} */}

            {/* {propertyName && currentStep === 2 && (
              <button
                className="px-6 py-3 w-44 text-center bg-customGreen text-white rounded-md"
                onClick={handleTowerInfoManage}
              >
                Update Tower
              </button>
            )} */}
          </div>

          {currentStep === 1 && (
            <ApartmentPropertyInfoForm
              propertyInfo={propertyInfo}
              setPropertyInfo={setPropertyInfo}
              handlePropertyInfoChange={handlePropertyInfoChange}
              handleArrayFieldChange={handleArrayFieldChange}
              handleNestedPropertyInfoChange={handleNestedPropertyInfoChange}
              isEdit={editMode}
              propertyType={propertyInfo?.propertyType}
              propertySaleTypesName={propertySaleTypesName}
            />
          )}

          {currentStep === 2 && (
            <TowerInfoForm
              onDataChange={handleTowerInfoChange}
              initialTowers={towers}
              isEdit={editMode}
            />
          )}

          {currentStep === 3 && (
            <>
              <ApartmentUnitTable
                towers={towers}
                units={filteredUnits}
                propertyId={propertyInfo?.docId}
                totalUnitsPerTower={totalUnitsPerTower}
                onEdit={handleEditUnit}
                lastUnitTrigger={lastUnitTrigger}
                onAdd={handleAddUnit}
                isEdit={editMode}
                handleSetLoading={clickLoading}
                selectedTowerId={handleSelectedTowerId}
                onTotalUnitsChange={handleTotalUnitsChange}
                filterUnits={filterUnits}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApartmentPropertyManage;
